'use client'

import { FC } from "react";
import { Container, Wrapper } from "@/features/pages/home";
import { Typography } from "@mui/material";
import { Head, ListBox, StyledButton } from "./styles";

import blogPostOne from "@/assets/webp/blog-post-1.webp";
import blogPostTwo from "@/assets/webp/blog-post-2.webp";
import blogPostThree from "@/assets/webp/blog-post-3.webp";
import { Card } from "./Card";
import { PATHS, COLORS } from "@/constants";
import { ArrowRight } from "@/components";
import { useTranslations } from "next-intl";
import Link from "next/link";

const MOCKED_BLOCK_ARCTICLES = [
  {
    img: blogPostOne.src,
    date: "6. Oktober 2023",
    title: "5 wichtige Faktoren bei der Wahl Ihres perfekten Zuhauses",
    desc: "Die richtige Wohnung zu finden, hängt nicht nur vom Preis ab – es geht auch um Lage, Annehmlichkeiten und langfristigen Wert. Hier sind die Punkte, auf die Sie achten sollten, bevor Sie eine Entscheidung treffen.",
  },
  {
    img: blogPostTwo.src,
    date: "7. Oktober 2023",
    title: "Mieten oder Kaufen: Welche Option ist die richtige für Sie?",
    desc: "Sie wissen nicht, ob Sie mieten oder kaufen sollen? Wir analysieren die Vor- und Nachteile beider Optionen, um Ihnen zu helfen, die beste finanzielle und lebensstilbezogene Entscheidung zu treffen.",
  },
  {
    img: blogPostThree.src,
    date: "8. Oktober 2023",
    title: "Verborgene Kosten beim Kauf eines Hauses, die Sie nicht ignorieren sollten",
    desc: "Der Preis ist nicht die einzige Ausgabe – Grundsteuern, Instandhaltung und Abschlusskosten können sich summieren. Hier sind die Punkte, für die Sie beim Kauf eines Hauses budgetieren sollten.",
  },
];

export const Blog: FC = () => {
  const t = useTranslations();
  return (
    <Wrapper>
      <Container>
        <Head>
          <Typography fontSize={{ xs: 26, sm: 26, md: 34 }} fontWeight={700} color={COLORS["blue-dark"]}>
            {t("blog.title")}
          </Typography>
          <Link href={`/${PATHS.BLOG}`}>
            <StyledButton variant="outlined" endIcon={<ArrowRight
              width={14}
              height={14}
              stroke={"#D25D3E"}
              fill={"#D25D3E"}
            />}>
              <Typography fontSize={14} fontWeight={600} textTransform={"none"} lineHeight={1}>
                {t("blog.button")}
              </Typography>
            </StyledButton>
          </Link>
        </Head>

        <ListBox>{MOCKED_BLOCK_ARCTICLES?.map((e, i) => <Card data={e} key={i} />)}</ListBox>
      </Container>
    </Wrapper>
  );
};
